import api from "./apiService";
import { API_PASSWORD } from "./apiConfig";

/**
 * جلب بيانات التجديدات (renews)
 * @param {Object} params - أي معلمات استعلام إضافية (مثل tenant_id، page، ...)
 * @param {string} token - توكن مصادقة (Bearer) اختياري
 * @returns {Promise} Promise من axios
 *
 * مثال:
 * getRenews({ tenant_id: 'kawkabelsharq' }, 'eyJhbGci...').then(...)
 */
export const getRenews = (params = {}, token) => {
  // احصل على التوكن من الوسائط أو من localStorage (مفاتيح شائعة)
  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ ...params, api_password: API_PASSWORD }).toString();

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
  };

  return api.get(`get/renews?${query}`, { headers });
};

// أضفنا دالة لإنشاء سجل تجديد (ترسل form-data إلى renew/system)
export const createRenew = async (data = {}, token) => {
  // توكن من الوسائط أو من localStorage
  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  // بناء FormData (يتعامل مع الملفات إن وُجدت)
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === undefined || value === null) return;
    // إذا كانت مصفوفة نضيف كل قيمة بعنصر منفصل (key[])
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(`${key}[]`, v));
    } else {
      formData.append(key, value);
    }
  });

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
    // لا نحدد Content-Type هنا حتى يضبطه المتصفح مع boundary عند إرسال FormData
  };

  return api.post(`renew/system?${query}`, formData, { headers });
};

// أضفنا دالة لتعديل سجل التجديد (edite/renew/system/{id})
export const editRenew = async (id, data = {}, token) => {
  if (!id) throw new Error("renew id is required");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(`${key}[]`, v));
    } else {
      formData.append(key, value);
    }
  });

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
  };

  // استخدم endpoint التعديل مع المعرف
  return api.post(`edite/renew/system/${id}?${query}`, formData, { headers });
};

// أضفنا دالة لحذف سجل التجديد (delete/renew/{id})
export const deleteRenew = async (id, token) => {
  if (!id) throw new Error("renew id is required for delete");

  const storedToken =
    token ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("authToken") ||
    null;

  const query = new URLSearchParams({ api_password: API_PASSWORD }).toString();

  const headers = {
    ...(storedToken ? { Authorization: `Bearer ${storedToken}` } : {}),
    Accept: "application/json",
  };

  // ملاحظة: الـ API يستخدم مسار GET لحذف التجديدات في مثال Postman
  return api.get(`delete/renew/${id}?${query}`, { headers });
};

export default {
  getRenews,
  createRenew,
  editRenew,
  deleteRenew,
};
